/* eslint-disable no-use-before-define */

import months from '../months.json';

export function usePreviewtoString(detail, lang, logo, width) {
    const hrPrivacyPolicy = detail?.hrPrivacyPolicy;
    const hrIntroductionLawfulBasis = detail?.hrIntroductionLawfulBasis;
    const hrPersonalDataCollect = detail?.hrPersonalDataCollect;
    const hrReasonCollectedData = detail?.hrReasonCollectedData;
    const hrTransferPersonalData = detail?.hrTransferPersonalData;
    const hrRetainPersonalData = detail?.hrRetainPersonalData;
    const hrDataSubjectRight = detail?.hrDataSubjectRight;
    const hrPolicyChange = detail?.hrPolicyChange;

    const formatMonth = (month) => {
        const item = months.find((res) => res.id === month + 1);
        return lang === 'TH' ? item?.monthTh : item?.monthEn;
    };

    const formatYear = (year) => {
        return lang === 'TH' ? year + 543 : year;
    };

    const getCurrentDate = (date) => {
        const updateDate = date?.split(' ')[0];
        const dateItem = `${updateDate?.split('/')[1]}/${
            updateDate?.split('/')[0]
        }/${updateDate?.split('/')[2]}`;
        const currentDate = new Date(dateItem);
        const day = currentDate?.getDate();
        const month = formatMonth(Number(currentDate.getMonth()));
        const year = formatYear(Number(currentDate.getFullYear()));
        const formatDate = `${day} ${month} ${year}`;
        return formatDate;
    };

    let date = '';
    if (hrPrivacyPolicy?.updateDate) {
        const split = hrPrivacyPolicy?.updateDate.split('/');
        const year = split[2].split(' ');
        const date_ = `_${split[0]}-${split[1]}-${year[0]}_`;
        date = date_;
    }

    const body = `
    <body style="word-break: break-word;">
        <center>
        ${
            logo &&
            `<img
            width="${width}"
             height="100"
        style="object-fit: cover;"
        src=${logo}
        alt="logo "/>`
        }</center>
        <center>
            <h3>
                ${
                    lang === 'TH'
                        ? hrPrivacyPolicy?.hrPrivacyPolicyNameTh
                        : hrPrivacyPolicy?.hrPrivacyPolicyNameEn
                }
            </h3>
        </center>
            <p className="text-left">
                ${
                    hrIntroductionLawfulBasis?.hrIntroductionIsDisplay === true
                        ? lang === 'TH'
                            ? hrIntroductionLawfulBasis?.hrIntroductionContentTh ||
                              '-'
                            : hrIntroductionLawfulBasis?.hrIntroductionContentEn ||
                              '-'
                        : ''
                }
            </p>
        <h4>
                ${
                    hrIntroductionLawfulBasis?.hrLawfulBasisIsDisplay === true
                        ? lang === 'TH'
                            ? hrIntroductionLawfulBasis?.hrLawfulBasisTitleTh
                            : hrIntroductionLawfulBasis?.hrLawfulBasisTitleEn
                        : ''
                }
            </h4>
        <p className="indent-8 text-left">
                ${
                    hrIntroductionLawfulBasis?.hrLawfulBasisIsDisplay === true
                        ? lang === 'TH'
                            ? hrIntroductionLawfulBasis?.hrLawfulBasisContentTh ||
                              '-'
                            : hrIntroductionLawfulBasis?.hrLawfulBasisContentEn ||
                              '-'
                        : ''
                }
            </p>
        <h4>
                ${
                    hrPersonalDataCollect?.hrPersonalDataIsDisplay === true
                        ? lang === 'TH'
                            ? hrPersonalDataCollect?.hrPersonalDataTitleTh
                            : hrPersonalDataCollect?.hrPersonalDataTitleEn
                        : ''
                }
            </h4>
        <p className="indent-8 text-left">
            ${
                hrPersonalDataCollect?.hrPersonalDataIsDisplay === true
                    ? lang === 'TH'
                        ? hrPersonalDataCollect?.hrPersonalDataContentTh || '-'
                        : hrPersonalDataCollect?.hrPersonalDataContentEn || '-'
                    : ''
            }
        </p>
        <h4>
            ${
                hrPersonalDataCollect?.hrSourceIsDisplay === true
                    ? lang === 'TH'
                        ? hrPersonalDataCollect?.hrSourceTitleTh
                        : hrPersonalDataCollect?.hrSourceTitleEn
                    : ''
            }
        </h4>
        <p className="indent-8 text-left">
            ${
                hrPersonalDataCollect?.hrSourceIsDisplay === true
                    ? lang === 'TH'
                        ? hrPersonalDataCollect?.hrSourceContentTh || '-'
                        : hrPersonalDataCollect?.hrSourceContentEn || '-'
                    : ''
            }
        </p>
        <h4>
            ${
                hrReasonCollectedData?.hrPurposeIsDisplay === true
                    ? lang === 'TH'
                        ? hrReasonCollectedData?.hrPurposeTitleTh
                        : hrReasonCollectedData?.hrPurposeTitleEn
                    : ''
            }
        </h4>
        <p className="indent-8 text-left">
            ${
                hrReasonCollectedData?.hrPurposeIsDisplay === true
                    ? lang === 'TH'
                        ? hrReasonCollectedData?.hrPurposeContentTh || '-'
                        : hrReasonCollectedData?.hrPurposeContentEn || '-'
                    : ''
            }
        </p>
        <h4>
            ${
                hrTransferPersonalData?.hrDisclosureIsDisplay === true
                    ? lang === 'TH'
                        ? hrTransferPersonalData?.hrDisclosureTitleTh
                        : hrTransferPersonalData?.hrDisclosureTitleEn
                    : ''
            }
        </h4>
        <p className="indent-8 text-left">
            ${
                hrTransferPersonalData?.hrDisclosureIsDisplay === true
                    ? lang === 'TH'
                        ? hrTransferPersonalData?.hrDisclosureContentTh || '-'
                        : hrTransferPersonalData?.hrDisclosureContentEn || '-'
                    : ''
            }
        </p>
        <h4>
            ${
                hrTransferPersonalData?.hrInternationalIsDisplay === true
                    ? lang === 'TH'
                        ? hrTransferPersonalData?.hrInternationalTitleTh || '-'
                        : hrTransferPersonalData?.hrInternationalTitleEn || '-'
                    : ''
            }
        </h4>
        <p className="indent-8 text-left">
                ${
                    hrTransferPersonalData?.hrInternationalIsDisplay === true
                        ? lang === 'TH'
                            ? hrTransferPersonalData?.hrInternationalContentTh ||
                              '-'
                            : hrTransferPersonalData?.hrInternationalContentEn ||
                              '-'
                        : ''
                }
            </p>
        <h4>
                ${
                    hrRetainPersonalData?.hrRetentionIsDisplay === true
                        ? lang === 'TH'
                            ? hrRetainPersonalData?.hrRetentionTitleTh
                            : hrRetainPersonalData?.hrRetentionTitleEn
                        : ''
                }
            </h4>
        <p className="indent-8 text-left">
                ${
                    hrRetainPersonalData?.hrRetentionIsDisplay === true
                        ? lang === 'TH'
                            ? hrRetainPersonalData?.hrRetentionContentTh || '-'
                            : hrRetainPersonalData?.hrRetentionContentEn || '-'
                        : ''
                }
            </p>
        <h4>
                ${
                    hrRetainPersonalData?.hrSecurityIsDisplay === true
                        ? lang === 'TH'
                            ? hrRetainPersonalData?.hrSecurityTitleTh
                            : hrRetainPersonalData?.hrSecurityTitleEn
                        : ''
                }
            </h4>
        <p className="indent-8 text-left">
                ${
                    hrRetainPersonalData?.hrSecurityIsDisplay === true
                        ? lang === 'TH'
                            ? hrRetainPersonalData?.hrSecurityContentTh || '-'
                            : hrRetainPersonalData?.hrSecurityContentEn || '-'
                        : ''
                }
            </p>
        <h4>
                ${
                    hrDataSubjectRight?.hrDataSubjectRightIsDisplay === true
                        ? lang === 'TH'
                            ? hrDataSubjectRight?.hrDataSubjectRightTitleTh
                            : hrDataSubjectRight?.hrDataSubjectRightTitleEn
                        : ''
                }
            </h4>
        <p className="indent-8 text-left">
                ${
                    hrDataSubjectRight?.hrDataSubjectRightIsDisplay === true
                        ? lang === 'TH'
                            ? hrDataSubjectRight?.hrDataSubjectRightContentTh ||
                              '-'
                            : hrDataSubjectRight?.hrDataSubjectRightContentEn ||
                              '-'
                        : ''
                }
            </p>
        <h4>
                ${
                    hrPolicyChange?.hrChangeIsDisplay === true
                        ? lang === 'TH'
                            ? hrPolicyChange?.hrChangeTitleTh
                            : hrPolicyChange?.hrChangeTitleEn
                        : ''
                }
            </h4>
        <p className="indent-8 text-left">
                ${
                    hrPolicyChange?.hrChangeIsDisplay === true
                        ? lang === 'TH'
                            ? hrPolicyChange?.hrChangeContentTh || '-'
                            : hrPolicyChange?.hrChangeContentEn || '-'
                        : ''
                }
            </p>
        <h4>
                ${
                    hrPolicyChange?.hrDataControllerIsDisplay === true
                        ? lang === 'TH'
                            ? hrPolicyChange?.hrDataControllerTitleTh
                            : hrPolicyChange?.hrDataControllerTitleEn
                        : ''
                }
            </h4>
        <p className="indent-8 text-left">
                ${
                    hrPolicyChange?.hrDataControllerIsDisplay === true
                        ? lang === 'TH'
                            ? hrPolicyChange?.hrDataControllerContentTh || '-'
                            : hrPolicyChange?.hrDataControllerContentEn || '-'
                        : ''
                }
            </p>
        <h4>
                ${
                    hrPolicyChange?.hrDataProtectionIsDisplay === true
                        ? lang === 'TH'
                            ? hrPolicyChange?.hrDataProtectionTitleTh
                            : hrPolicyChange?.hrDataProtectionTitleEn
                        : ''
                }
            </h4>
        <p className="indent-8 text-left">
                ${
                    hrPolicyChange?.hrDataProtectionIsDisplay === true
                        ? lang === 'TH'
                            ? hrPolicyChange?.hrDataProtectionContentTh || '-'
                            : hrPolicyChange?.hrDataProtectionContentEn || '-'
                        : ''
                }
            </p>
        <h4>${lang === 'TH' ? 'ฉบับ ณ วันที่' : 'Edition as of'}&nbsp;&nbsp;
                ${getCurrentDate(hrPrivacyPolicy?.effectiveDate)}</h4>
        <script type="text/javascript">
                $(document).ready(function() {
                let allElements = $('*');
                let converted = htmlDocx.asBlob(allElements.html());
                saveAs(converted, '${
                    lang === 'TH'
                        ? hrPrivacyPolicy?.hrPrivacyPolicyNameTh +
                          `${date}TH.docx`
                        : hrPrivacyPolicy?.hrPrivacyPolicyNameEn +
                          `${date}EN.docx`
                }');
                setTimeout(()=> window.close(), 100)
                });
        </script>
            </body>
    `;

    return {
        html: `
        <html>
        <head>
            <meta charset="UTF-8" />
            <title>Document</title>
            <script type="text/javascript" src="https://ajax.googleapis.com/ajax/libs/jquery/1.6.2/jquery.min.js"></script>
            <script src="https://cdnjs.cloudflare.com/ajax/libs/FileSaver.js/2.0.5/FileSaver.min.js"></script>
            <script src="https://evidenceprime.github.io/html-docx-js/build/html-docx.js"></script>
        </head>
            ${body}
        </html>`,
        body,
    };
}
